/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalPostAccessSummaryPreviewRequestBody = OperationRequestBodyContent<
  operations['internalPostAccessSummaryPreview']
>;

export interface Input {
  apiVersion?: string;
  body: InternalPostAccessSummaryPreviewRequestBody;
}

export async function internalPostAccessSummaryPreview(
  { apiVersion, body }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/members/access-summary/preview', {
    params: {},
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
